module.exports = require('./spinner_three_bounce')



// WEBPACK FOOTER //
// ./src/plugins/spinner_three_bounce/index.js